var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "toggle-dark-theme" },
    [
      _vm.theme === "dark"
        ? _c("icon-weather-sunny", {
            attrs: { title: _vm.$t("user.enabledDarkTheme") },
            on: { click: _vm.onToggle },
          })
        : _c("icon-weather-night", {
            attrs: { title: _vm.$t("user.disabledDarkTheme") },
            on: { click: _vm.onToggle },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }